<script>
import { list } from '@/api/usuario'

export default {
  props: {
    model: {
      type: Object,
      default: () => ({})
    }
  },
  methods: {
    async autocomplete ({ searchValue, qtd, page }) {
      let result = await list({ nome: searchValue, qtd, page })
      return result.data
    }
  }
}
</script>

<template>
  <ui-auto-complete-busca
    ref="fieldBusca"
    :model="model"
    field="nome"
    width="1000"
    component="app-usuario-grid"
    label="Usuário"
    @change="v => $emit('change', v)"
    :autocomplete="autocomplete" />
</template>
